export default __webpack_public_path__ + "static/user2-614fdfd00d2f3a1de392b3c3eb225390.jpg";